export enum SupportContentType {
  SUPPORT_REQUESTS = 'support_requests',
  ISSUES = 'issues',
  ATTACHMENTS = 'attachments',
  ISSUES_ATTACHMENTS = 'issues_attachments',
  SUPPORT_REQUESTS_ATTACHMENTS = 'support_requests_attachments',
  TASKS = 'tasks',
  EMPTY = '',
}
